import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import St from "./auth-manager.js";
import y from "../common/base-provider.js";
import et from "../util/browser-detector.js";
import It from "./device-manager.js";
import DeviceProperties from "../Core/device-properties.js";
import { isArray as p, keys as rr, validateValueIsFromEnum as F, values as At } from "../util/code-utils.js";
import { logDeprecationWarning as D } from "../util/deprecation-utils.js";
import wt from "./network-manager.js";
import Ot from "../request-controller.js";
import Ct from "./server-config-manager.js";
import Lt from "./session-manager.js";
import r from "../../shared-lib/braze-shared-lib.js";
import G, { STORAGE_KEYS as o } from "./storage-manager.js";
import Pt from "./storage-manager-factory.js";
import u from "./subscription-manager.js";
import { TriggersProviderFactory as W } from "../triggers/triggers-provider-factory.js";
import bt from "../User/user-manager.js";
import { User } from "../User/index.js";
import { parseQueryStringKeyValues as st } from "../util/url-utils.js";
import { WindowUtils as H } from "../util/window-utils.js";
var T = {
  Rn: "allowCrawlerActivity",
  Wn: "baseUrl",
  Vn: "noCookies",
  Yn: "devicePropertyAllowlist",
  ta: "disablePushTokenMaintenance",
  Xn: "enableLogging",
  Zn: "enableSdkAuthentication",
  ia: "manageServiceWorkerExternally",
  ho: "minimumIntervalBetweenTriggerActionsInSeconds",
  po: "sessionTimeoutInSeconds",
  Eo: "appVersion",
  na: "serviceWorkerLocation",
  ra: "safariWebsitePushId",
  jn: "localization",
  ao: "contentSecurityNonce",
  _o: "enableHtmlInAppMessages",
  Io: "allowUserSuppliedJavascript",
  no: "inAppMessageZIndex",
  lo: "openInAppMessagesInNewTab",
  tn: "openCardsInNewTab",
  en: "openNewsFeedCardsInNewTab",
  Ui: "requireExplicitInAppMessageDismissal",
  Ao: "doNotLoadFontAwesome",
  So: "sdkFlavor"
};

var Rt = /*#__PURE__*/function () {
  function Rt() {
    _classCallCheck(this, Rt);

    this.No = !1, this.wo = !1, this.To = new u(), this.Oo = new u(), this.vo = {}, this.Co = [], this.Lo = [], this.De = [], this.Po = "4.3.0";
  }

  _createClass(Rt, [{
    key: "Ro",
    value: function Ro(t) {
      this.To.ut(t);
    }
  }, {
    key: "Bi",
    value: function Bi(t) {
      this.Oo.ut(t);
    }
  }, {
    key: "initialize",
    value: function initialize(t, i) {
      var _this = this;

      if (this.Mo()) return r.D.info("Braze has already been initialized with an API key."), !0;
      this.vo = i || {};
      var s = this.nn(T.Xn);
      var e = st(H.hn());
      if (e && "true" === e.brazeLogging && (s = !0), r.D.init(s), r.D.info("Initialization Options: ".concat(JSON.stringify(this.vo, null, 2))), null == t || "" === t || "string" != typeof t) return r.D.error("Braze requires a valid API key to be initialized."), !1;
      this.Ji = t;
      var n = this.nn(T.Wn);
      if (null == n || "" === n || "string" != typeof n) return r.D.error("Braze requires a valid baseUrl to be initialized."), !1;
      !1 === /^https?:/.test(n) && (n = "https://".concat(n));
      var a = n;
      if (n = document.createElement("a"), n.href = a, "/" === n.pathname && (n = "".concat(n, "api/v3")), this.yo = n.toString(), et.Do && !this.nn(T.Rn)) return r.D.info("Ignoring activity from crawler bot " + navigator.userAgent), this.wo = !0, !1;
      var h = this.nn(Rt.Vn) || !1;
      if (this.h = Pt.jo(t, h), new G.ne(null, !0).lr(o.ae)) return r.D.info("Ignoring all activity due to previous opt out"), this.wo = !0, !1;

      var _iterator = _createForOfIteratorHelper(rr(this.vo)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t3 = _step.value;
          -1 === At(r.Uo).indexOf(_t3) && r.D.warn("Ignoring unknown initialization option '".concat(_t3, "'."));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var l = ["mparticle", "wordpress", "tealium"];

      if (null != this.nn(T.So)) {
        var _t = this.nn(T.So);

        -1 !== l.indexOf(_t) ? this.zo = _t : r.D.error("Invalid sdk flavor passed: " + _t);
      }

      var c = this.nn(r.Uo.Yn);
      if (null != c) if (p(c)) {
        var _t2 = [];

        for (var _i = 0; _i < c.length; _i++) {
          F(DeviceProperties, c[_i], "devicePropertyAllowlist contained an invalid value.", "DeviceProperties") && _t2.push(c[_i]);
        }

        c = _t2;
      } else r.D.error("devicePropertyAllowlist must be an array. Defaulting to all properties."), c = null;
      this.Qi = new It(this.h, c), this.gt = new Ct(this.h), this.v = new bt(this.gt, this.h), this.j = new Lt(this.h, this.v, this.gt, this.nn(T.po));
      var m = new u();
      return this.Bo = new St(this.h, this.nn(T.Zn), m), this.jt(m), this.vt = new wt(this.Qi, this.h, this.Bo, this.v, this.j, this.gt, this.Ji, this.yo, this.Po, this.zo, this.nn(T.Eo)), this.si = new Ot(this.Ji, this.yo, this.j, this.Qi, this.v, this.gt, this.h, function (t) {
        if (_this.Mo()) {
          var _iterator2 = _createForOfIteratorHelper(_this.re()),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _i2 = _step2.value;

              _i2.Rs(t);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }, this.Bo, this.vt), this.si.initialize(), r.D.info("Initialized for the Braze backend at \"".concat(this.nn(T.Wn), "\" with API key \"").concat(this.Ji, "\".")), null != this.nn(T._o) && D("enableHtmlInAppMessages", "initialization option", "allowUserSuppliedJavascript"), W.init(), this.To.St(this.vo), this.No = !0, !0;
    }
  }, {
    key: "destroy",
    value: function destroy(t) {
      if (r.D.destroy(), this.Mo()) {
        this.Oo.St(), this.Oo.removeAllSubscriptions();

        var _iterator3 = _createForOfIteratorHelper(this.Co),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _t4 = _step3.value;

            _t4.destroy();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        this.Co = [];

        var _iterator4 = _createForOfIteratorHelper(this.Lo),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t5 = _step4.value;

            _t5.clearData(!1);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.Lo = [], this.removeAllSubscriptions(), this.De = [], this.si.destroy(), this.si = null, this.Bo = null, this.Qi = null, this.vt = null, this.gt = null, this.j = null, this.v = null, this.vo = {}, this.zo = void 0, this.No = !1, this.wo = !1, t && (this.h = null);
      }
    }
  }, {
    key: "rr",
    value: function rr() {
      if (this.Wo()) return !1;
      if (!this.Mo()) throw new Error("Braze must be initialized before calling methods.");
      return !0;
    }
  }, {
    key: "ea",
    value: function ea() {
      return this.Ji;
    }
  }, {
    key: "ii",
    value: function ii() {
      return this.Bo;
    }
  }, {
    key: "Ks",
    value: function Ks() {
      return this.yo;
    }
  }, {
    key: "ce",
    value: function ce() {
      return this.Qi;
    }
  }, {
    key: "nr",
    value: function nr() {
      return this.vt;
    }
  }, {
    key: "nn",
    value: function nn(t) {
      return this.vo[t];
    }
  }, {
    key: "re",
    value: function re() {
      return this.Lo;
    }
  }, {
    key: "mr",
    value: function mr() {
      return this.si;
    }
  }, {
    key: "ir",
    value: function ir() {
      return this.gt;
    }
  }, {
    key: "g",
    value: function g() {
      return this.j;
    }
  }, {
    key: "l",
    value: function l() {
      return this.h;
    }
  }, {
    key: "gr",
    value: function gr() {
      if (this.v && this.si) return new User(this.v, this.si);
    }
  }, {
    key: "p",
    value: function p() {
      return this.v;
    }
  }, {
    key: "tr",
    value: function tr() {
      return !0 === this.nn(T.Io) || !0 === this.nn(T._o);
    }
  }, {
    key: "u",
    value: function u(t) {
      var i = !1;

      var _iterator5 = _createForOfIteratorHelper(this.Co),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var s = _step5.value;
          s === t && (i = !0);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      i || this.Co.push(t);
    }
  }, {
    key: "ar",
    value: function ar(t) {
      var i = !1;

      var _iterator6 = _createForOfIteratorHelper(this.Lo),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var s = _step6.value;
          s.constructor === t.constructor && (i = !0);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      t instanceof y && !i && this.Lo.push(t);
    }
  }, {
    key: "jt",
    value: function jt(t) {
      t instanceof u && this.De.push(t);
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      if (this.rr()) {
        var _iterator7 = _createForOfIteratorHelper(this.De),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var t = _step7.value;
            t.removeAllSubscriptions();
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(t) {
      if (this.rr()) {
        var _iterator8 = _createForOfIteratorHelper(this.De),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var i = _step8.value;
            i.removeSubscription(t);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    }
  }, {
    key: "le",
    value: function le(t) {
      this.wo = t;
    }
  }, {
    key: "Mo",
    value: function Mo() {
      return this.No;
    }
  }, {
    key: "Wo",
    value: function Wo() {
      return this.wo;
    }
  }, {
    key: "Ds",
    value: function Ds() {
      return this.Po;
    }
  }]);

  return Rt;
}();

var e = new Rt();
export { e as default, Rt as BrazeSdkInstance, T as OPTIONS };